import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretUp,
  faFileSignature,
  faListOl,
  faLock,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import {
  deleteInputArgument,
  moveInputArgument,
  moveInputArgumentDown,
  moveInputArgumentUp,
  selectInputArguments,
  selectVariableGroups,
} from "../../../store/slices/projectSlice";
import { setCurrentModal } from "../../../store/slices/modalsSlice";
import Input from "../../nodes/Logic/Inputs/Input";

export default function InputArguments() {
  const [variableFilter, setVariableFilter] = useState("");
  const inputArguments = useSelector(selectInputArguments)?.filter(
    (arg) =>
      !variableFilter ||
      (variableFilter === "public" && arg.IsParameter) ||
      (variableFilter === "private" && !arg.IsParameter)
  );
  const variableGroups = useSelector(selectVariableGroups);
  const dispatch = useDispatch();
  const [dragTarget, setDragTarget] = useState();
  const [dragging, setDragging] = useState(false);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-center">
        <h5 className="card-title">Variables</h5>
        <div className="ms-2">
          <Input
            inputType="radio"
            radioName="inputVariableFIlter"
            value={[variableFilter]}
            onChange={([v]) => {
              setVariableFilter(v);
            }}
            options={[
              { value: "", label: "All" },
              { value: "public", label: "Public" },
              { value: "private", label: "Private" },
            ]}
          />
        </div>
        <HelpButton helpKey="variables" />
        <div className="flex-grow-1" />
        <button
          type="button"
          onClick={() => {
            dispatch(
              setCurrentModal({
                modal: "inputArgument",
                tab: "create",
                data: { inputArgumentUUID: "create_new" },
              })
            );
          }}
          className="btn btn-outline-primary btn-sm border-0"
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
      <div className="card-body p-0">
        {inputArguments.length > 0 ? (
          <ul className={`list-group list-group-flush`}>
            {[...inputArguments]
              .sort((a, b) => a.Order - b.Order)
              .map((variable, index) => (
                <li
                  draggable
                  onDragOver={(e) => {
                    e.preventDefault();
                    if (dragging) {
                      setDragTarget(index);
                    }
                  }}
                  onDragEnd={(e) => {
                    if (
                      dragging &&
                      dragTarget !== undefined &&
                      dragTarget !== index
                    ) {
                      dispatch(
                        moveInputArgument({
                          sourceIndex: index,
                          destinationIndex: dragTarget,
                        })
                      );
                    }
                    setDragTarget();
                    setDragging(false);
                  }}
                  onDragStart={() => setDragging(true)}
                  key={variable.UUID}
                  className={`list-group-item p-0`}
                >
                  {dragTarget === index && (
                    <div className="p-1 bg-purple-gradient"></div>
                  )}
                  <div
                    className={`m-0 py-1 px-2 d-flex justify-content-between align-items-center`}
                  >
                    <div className="m-0 me-2">
                      <button
                        className="btn d-block p-0 px-1 btn-outline-secondary border-0 mb-n2"
                        onClick={() => {
                          dispatch(moveInputArgumentUp(variable.UUID));
                        }}
                        disabled={index === 0}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </button>
                      <button
                        className="btn d-block p-0 px-1 btn-outline-secondary border-0 mt-n2"
                        onClick={() => {
                          dispatch(moveInputArgumentDown(variable.UUID));
                        }}
                        disabled={index === inputArguments.length - 1}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </button>
                    </div>
                    <div className="m-0">
                      <button
                        type="button"
                        onClick={() => {
                          dispatch(
                            setCurrentModal({
                              modal: "inputArgument",
                              tab: "create",
                              data: { inputArgumentUUID: variable.UUID },
                            })
                          );
                        }}
                        className="btn btn-link text-start p-0"
                      >
                        {variable.Label}{" "}
                      </button>
                      <div className="text-secondary small m-0">
                        {variableGroups.find(
                          (vg) => vg.GroupUuid === variable.GroupUuid
                        )?.Label || variable.GroupUuid}
                      </div>
                    </div>
                    <span
                      className={`ms-auto badge me-1 ${
                        variable.IsParameter ? "bg-colored" : "bg-secondary"
                      }`}
                      // style={{ width: "60px" }}
                    >
                      {variable.IsMultiple && (
                        <FontAwesomeIcon icon={faListOl} className="mx-1" />
                      )}
                      {variable.IsReadOnly && (
                        <FontAwesomeIcon icon={faLock} className="mx-1" />
                      )}
                      {variable.IsParameter && (
                        <FontAwesomeIcon
                          icon={faFileSignature}
                          className="mx-1"
                        />
                      )}
                      {variable.Format}
                    </span>

                    <UsedInBadge
                      arg={variable}
                      alt={
                        // eslint-disable-next-line jsx-a11y/control-has-associated-label
                        <button
                          type="button"
                          title="Delete argument"
                          className="btn btn-outline-danger btn-sm border-0 px-1"
                          style={{ width: 22 }}
                          onClick={() =>
                            dispatch(deleteInputArgument(variable.UUID))
                          }
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      }
                    />
                  </div>
                </li>
              ))}
          </ul>
        ) : (
          <div className="text-center m-1">No variables</div>
        )}
      </div>
    </div>
  );
}
